module.exports = __webpack_public_path__ + "media/images/pc/brands/sola/store_sapporo@3x-f0c1ec73804d533feae2ed6c064d400d.webp";